var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdminBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.276,
    height: 31.528,
    viewBox: "0 0 28.276 31.528",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "df7694c2aaaf6b95c8c66453452cafd7",
    transform: "translate(-60.6 -10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_555",
    "data-name": "Caminho 555",
    d: "M74.247,39.958l-1.56-2.706a1.968,1.968,0,0,1,.721-2.69l.344-.2a6.578,6.578,0,0,1,0-1.3l-.344-.2a1.974,1.974,0,0,1-.721-2.693l1.56-2.706a1.983,1.983,0,0,1,1.2-.917,1.969,1.969,0,0,1,1.5.2l.347.2a8.166,8.166,0,0,1,1.12-.637V25.9c0-.032.019-.061.019-.093a9.5,9.5,0,0,0-4.034-1.731V23.1a6.893,6.893,0,1,0-5.91,0v.975C60.629,25.584,60.6,33.189,60.6,37.587c0,3.433,15.015,3.336,14.847,3.291A1.965,1.965,0,0,1,74.247,39.958Z",
    transform: "translate(0 0)",
    fill: "#009ebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_556",
    "data-name": "Caminho 556",
    d: "M484.1,512.111a6.165,6.165,0,0,0-.251-1.66l1.547-.891-1.563-2.706-1.528.882a6.233,6.233,0,0,0-2.892-1.654V504.3h-3.124v1.782a6.221,6.221,0,0,0-2.892,1.654l-1.528-.882L470.3,509.56l1.547.891a6.3,6.3,0,0,0-.251,1.66,6.166,6.166,0,0,0,.251,1.66l-1.547.894,1.564,2.706,1.528-.881a6.243,6.243,0,0,0,2.9,1.654v1.782l3.124,0v-1.779a6.23,6.23,0,0,0,2.9-1.654l1.528.881,1.56-2.706-1.544-.891A6.3,6.3,0,0,0,484.1,512.111Zm-6.248,3.774a3.771,3.771,0,1,1,3.771-3.771A3.768,3.768,0,0,1,477.847,515.885Z",
    transform: "translate(-396.519 -478.398)",
    fill: "#009ebe"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminBlue);
export default __webpack_public_path__ + "static/media/adminBlue.2d80d582fbd6435e59aa36f47e737f4a.svg";
export { ForwardRef as ReactComponent };